module.exports = __webpack_public_path__ + "img/spot-hero.5fcc19de.svg";